module.exports = __webpack_public_path__ + "static/media/ios-safari-icon.3aba5b2d.svg";